export const withModifier = (name, styles) => ({
    '&[class]': Object.assign({ label: name && `-${name}` }, styles),
});
//# sourceMappingURL=withModifier.js.map
// @zapier/style-encapsulation@1.3.0 (e31aef2e9)
